<!--
 * @Auther: 罗耀祖
 * @Date: 2021-07-06 17:36:38
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-05-05 11:11:42
 * @name: 忘记密码
 * @Description: 忘记密码
 * @FilePath: \preSaleNafterSaleBackstage\src\views\ForgetPassword.vue
 * @Author: DESKTOP-1QU67QM
-->
<template>
  <div class="forgetPassword">
    <div class="card">
      <div class="info">
        <font class="title">忘记密码</font>
        <div class="line">
          <font class="label">手机号码</font>
          <el-input
            class="input"
            maxlength="11"
            @input="telephoneInput"
            :value="forgetPassword.telephone"
            placeholder="请输入手机号码"
            clearable
          ></el-input>
          <el-button
            type="primary"
            class="sendVerificationCode"
            size="mini"
            @click="sendVerificationCode"
            :disabled="countdown > 0"
          >
            {{ countdown === 0 ? "获取验证码" : countdown + "s" }}
          </el-button>
        </div>
        <div class="line">
          <font class="label">验证码</font>
          <el-input
            class="input"
            @input="verificationCodeInput"
            :value="forgetPassword.verificationCode"
            placeholder="请输入验证码"
            clearable
          ></el-input>
        </div>
        <div class="line">
          <font class="label">新密码</font>
          <el-input
            type="password"
            class="input"
            @input="newPasswordInput"
            :value="forgetPassword.newPassword"
            placeholder="请输入新密码"
            clearable
          ></el-input>
        </div>
        <font class="tips">新密码必须为6位以上数字、大小写字母组合</font>
        <div class="line">
          <font class="label">确认新密码</font>
          <el-input
            type="password"
            class="input"
            @input="newPasswordAgainInput"
            :value="forgetPassword.newPasswordAgain"
            placeholder="请输入新密码"
            clearable
          ></el-input>
        </div>
      </div>
      <div class="btnGroup">
        <el-button type="primary" @click="submit">确认</el-button>
        <el-button plain @click="cancel">取消</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import forgetPassword from "@/object/login/forgetPassword.class.js";
import sms from "@/object/sms/sms.class.js";
import { debounceation } from "@/utils/decorator";
export default {
  name: "forgetPassword",
  data() {
    return {
      sms: new sms(),
      forgetPassword: new forgetPassword(), //忘记密码对象实例
      countdown: 0, //验证码倒计时
      interval: "", //定时器
    };
  },
  destroyed() {
    clearInterval(this.interval);
  },
  methods: {
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 输入手机号
     * @param {String} e 手机号
     */
    telephoneInput(e) {
      this.forgetPassword.telephone = e;
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 输入验证码
     * @param {String} e 验证码
     */
    verificationCodeInput(e) {
      this.forgetPassword.verificationCode = e;
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 输入新密码
     * @param {String} e 新密码
     */
    newPasswordInput(e) {
      this.forgetPassword.newPassword = e;
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 输入新密码(再次)
     * @param {String} e 新密码(再次)
     */
    newPasswordAgainInput(e) {
      this.forgetPassword.newPasswordAgain = e;
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 点击获取验证码
     */
    @debounceation(300)
    sendVerificationCode() {
      this.sms.sendVerificationCode().then((res) => {
        this.countdown = this.sms.countdown; //重置验证码倒计时为sms对象实例短信有效期参数
        this.interval = setInterval(() => {
          if (this.countdown === 0) {
            clearInterval(this.interval);
          } else {
            this.countdown--;
          }
        }, 1000);
      });
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 点击确认
     */
    @debounceation(300)
    submit() {
      this.forgetPassword.submit().then((res) => {
        this.$router.go(-1);
      });
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 点击取消
     */
    @debounceation(300)
    cancel() {
      this.$router.go(-1);
    },
  },
};
</script>
<style lang="scss" scoped>
.forgetPassword {
  width: 100%;
  height: 100vh;
  @extend .extend-flex-center;
  background: $Vars-background-light-gray;
  .card {
    @extend .extend-card-login;
    .info {
      width: 500px;
      @extend .extend-flex-column-normal;
      .title {
        font-size: $Vars-font-mainTitle-size;
        font-weight: bold;
        margin-bottom: 20px;
      }
      .line {
        margin-top: 30px;
        @extend .extend-flex-start;
        .label {
          font-size: $Vars-font-content-size;
          text-align: left;
          width: 80px;
        }
        .input {
          width: 300px;
          margin-right: 20px;
        }
        .sendVerificationCode {
          width: 100px;
        }
      }
      .tips {
        margin-top: 30px;
        margin-left: 80px;
        font-size: $Vars-font-secondary-size;
        color: $Vars-font-placeholder-color;
      }
    }
    .btnGroup {
      margin-top: 30px;
      @include grid-column(2, 100px, 50px);
      justify-content: center;
      .el-button {
        width: 100px;
        margin: 0 !important;
      }
    }
  }
}
</style>